module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("team.title")))]), _vm._v(" "), _c('h4', {
    staticClass: "mb-20"
  }, [_vm._v(_vm._s(_vm.$t("team.subtitle")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryEmail),
      expression: "primaryEmail"
    }],
    staticClass: "form-control mb-20",
    attrs: {
      "id": "campaign-team-address",
      "placeholder": _vm.$t('team.primaryEmail')
    },
    domProps: {
      "value": (_vm.primaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.primaryEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    class: 'btn btn-default btn-lg button-wide-' + _vm.crowdOrRais,
    attrs: {
      "value": _vm.primaryEmail,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendInvitation(_vm.primaryEmail, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('alert', {
    attrs: {
      "success": _vm.alert.success,
      "error": _vm.alert.error
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "all-categories mt-0 mb-20"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("team.campaignTeam")))])]), _vm._v(" "), _c('p', {
    staticClass: "mb-20"
  }, [_vm._v(_vm._s(_vm.$t("team.campaignTeamDescription")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.memberEmail),
      expression: "memberEmail"
    }],
    staticClass: "form-control mb-20",
    attrs: {
      "type": "text",
      "id": "campaign-new-team-email",
      "placeholder": _vm.$t('team.campaignTeamEmail')
    },
    domProps: {
      "value": (_vm.memberEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.memberEmail = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    class: 'btn btn-default btn-lg mb-20 button-wide-' + _vm.crowdOrRais,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendInvitation(_vm.memberEmail, false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("team.campaignSendInvitationButton")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "all-categories mt-0 mb-20"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("team.campaignOwner")))])]), _vm._v(" "), _c('div', {
    staticClass: "owner"
  }, [_c('div', {
    staticClass: "avatar",
    staticStyle: {
      "height": "200px"
    }
  }, [(_vm.project.user.photo.thumb.url) ? _c('img', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "src": _vm.$server_url + _vm.project.user.photo.thumb.url
    }
  }) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.project.user.full_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('team.campaignTeam')))]), _vm._v(" "), _vm._l((_vm.collaborators), function(collaborator) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'show_profile',
          params: {
            id: collaborator.user.id
          }
        }
      }
    }, [_vm._v(_vm._s(collaborator.user.full_name))]), _vm._v(" "), (collaborator.confirmed) ? _c('span') : _vm._e(), _vm._v(" "), (collaborator.confirmation_sent_at) ? _c('span', [_vm._v(" - waiting for confirmation")]) : _vm._e()], 1)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bcc0ed0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Form/Team.vue
// module id = 784
// module chunks = 1